import React from 'react';
import classNames from 'classnames';

interface InputFieldProps {
  id: string;
  name: string;
  type?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  maxLength?: number;
  pattern?: string;
  className?: string;
  helpText?: string;
}

export const InputField: React.FC<InputFieldProps> = ({
  id,
  name,
  type = 'text',
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  required = false,
  disabled = false,
  autoComplete,
  maxLength,
  pattern,
  className,
  helpText,
}) => {
  const hasError = Boolean(error);

  return (
    <div className={classNames('space-y-1', className)}>
      <label
        htmlFor={id}
        className={classNames(
          'block text-sm font-medium',
          hasError ? 'text-error-700' : 'text-gray-700'
        )}
      >
        {label}
        {required && <span className="text-error-500 ml-1">*</span>}
      </label>
      
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        autoComplete={autoComplete}
        maxLength={maxLength}
        pattern={pattern}
        className={classNames(
          'form-input',
          hasError && 'error',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
        aria-invalid={hasError}
        aria-describedby={error ? `${id}-error` : helpText ? `${id}-help` : undefined}
      />
      
      {error && (
        <p id={`${id}-error`} className="text-sm text-error-600 animate-fade-in">
          {error}
        </p>
      )}
      
      {helpText && !error && (
        <p id={`${id}-help`} className="text-sm text-gray-500">
          {helpText}
        </p>
      )}
    </div>
  );
};
